import { Box, Image } from '@chakra-ui/react';
import getValidVideoAngle from 'features/utils/getValidVideoAngle';
import useAsset, { AssetType } from 'utils/hooks/useAsset';

type Props = {
  roofAngle: number;
  roofType: string;
  battery: boolean;
  vehicle: boolean;
  lightAmount: number;
  panelAssetIndex: number;
};

const SummaryHouseImage = ({
  roofAngle,
  roofType,
  battery,
  vehicle,
  lightAmount,
  panelAssetIndex,
}: Props) => {
  const imageWidth = 400;
  const validAngle = getValidVideoAngle(roofAngle);
  const baseImageUrl = useAsset(
    AssetType.IMAGE,
    validAngle === 0
      ? `/RECAP/roof_flat.png`
      : `/RECAP/roof_${roofType}_${validAngle}.png`
  );

  const lightImageUrl = useAsset(AssetType.IMAGE, `/RECAP/LIGHT.png`);
  const batteryImageUrl = useAsset(AssetType.IMAGE, `/RECAP/BATTERY.png`);
  const vehicleImageUrl = useAsset(AssetType.IMAGE, `/RECAP/CHARGE.png`);
  const panelImageUrl = useAsset(
    AssetType.IMAGE,
    `/RECAP/PANELS/${panelAssetIndex}-Pano-${
      validAngle === 0 ? 'Plat' : validAngle
    }.png`
  );

  return (
    <Box position="relative" marginTop="-50px" zIndex="-5" marginBottom="-50px">
      <Image alt="summary-image" src={baseImageUrl} width={imageWidth} />
      {battery && (
        <Image
          top="0"
          position="absolute"
          alt="battery-image"
          src={batteryImageUrl}
          width={imageWidth}
        />
      )}
      {vehicle && (
        <Image
          top="0"
          position="absolute"
          alt="vehicle-image"
          src={vehicleImageUrl}
          width={imageWidth}
        />
      )}

      <Image
        top="0"
        alt="light-intensity"
        src={lightImageUrl}
        sx={{ opacity: lightAmount }}
        position="absolute"
        width={imageWidth}
      />
      <Image
        top="0"
        position="absolute"
        alt="panel-image"
        src={panelImageUrl}
        width={imageWidth}
      />
    </Box>
  );
};

export default SummaryHouseImage;
